import React from "react";
import {Route} from "react-router-dom";

import RectifyIndex from "./index";

const data = [<Route exact key="RectifyIndex" path="/rectify/index" element={<RectifyIndex />} />];

export default data;
